import { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import JsonData from "./data/data.json";
import Home from "./Home";
import { Header } from "./components/header";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";
import { Privacypolicy } from "./components/privacypolicy";
import { initUserInteractionTracking } from "./userInteraction";

function App() {

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
    initUserInteractionTracking();
  }, []);
  return (
    <div className="App">
      <div className="social">
        <div className="pop">
          <a className="phonescreen" href="tel:9162281169">
            <img src="img/banners/hycall.png" alt="callus@9162281169" />
          </a>
        </div>
      </div>
    <Header />
    <Navigation />
    <Routes>
    <Route exact path="/" element={<Home />} />
    <Route exact path="/privacypolicy" element={<Privacypolicy />} />
    </Routes>
    <Footer />
    </div>
  );
}

export default App;
